import {
  DOMAIN_NAME,
  IS_LOCALHOST_TREATED_AS_CUSTOM_DOMAIN,
} from "utils/globalConsts";

const checkCurrDomainIsOrgDomain = () => {
  const hostname = window.location.hostname;

  if (hostname === "localhost") {
    return IS_LOCALHOST_TREATED_AS_CUSTOM_DOMAIN;
  }

  if (
    hostname.includes("amplify.jumbomail.me") ||
    hostname.includes("test.jumbomail.me") ||
    hostname.includes("test2.jumbomail.me") ||
    hostname.includes("www.jumbomail.me") ||
    hostname.includes("jumbomail.me")
  ) {
    return false;
  }

  return !hostname.includes(DOMAIN_NAME);
};

export default checkCurrDomainIsOrgDomain;
